<template>
  <o-view :has-white-background="true" :no-scroll="true">
    <o-view :bottom-padding="true">
      <o-nav-bar :has-back-button="true" title="4411 Parking" />
      <o-map :is-large="true" :markers="markers" />
      <o-section>
        <div class="u-flex">
          <o-text-input
            icon="car"
            placeholder="License Plate"
            :autocomplete-items="plates"
            class="u-flex__flexible"
          />
          <o-favorite-toggle v-if="$store.state.showFavoriteButton" />
        </div>
      </o-section>
      <o-section>
        <o-text-input icon="location" placeholder="Parking Zone" />
      </o-section>
      <o-section>
        <o-alert>
          - Starting a parking session costs €0,25.<br />
          - Consult the vendor machine for local rates.
        </o-alert>
      </o-section>
    </o-view>
    <o-pay-button label="Start session" />
  </o-view>
</template>

<script>
import OMap from '@/components/OMap.vue'
import OPayButton from '@/components/OPayButton.vue'
import OFavoriteToggle from '@/components/OFavoriteToggle.vue'

export default {
  name: 'Parking4411',
  components: {
    OMap,
    OPayButton,
    OFavoriteToggle
  },
  data() {
    return {
      plates: ['1-ABC-123', '1-BCD-234', '1-CDE-345', '1-DEF-456'],
      markers: [
        {
          coordinates: [3.715, 51.05],
          type: '4411'
        },
        {
          coordinates: [3.723, 51.053],
          type: '4411'
        },
        {
          coordinates: [3.72, 51.055],
          type: '4411'
        }
      ]
    }
  }
}
</script>
